export default {"src":"/_next/static/media/share-icon-fill.9c186a65.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};